import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'

import { useNetworkingDeclarationQuery, useNetworkingVocabulary } from './queries'

export type NetworkingAvailability = {
  /** Ainda não dá para decidir — a declaração está em voo. */
  isLoading: boolean
  /** Evento tem networking utilizável por este participante. */
  isAvailable: boolean
}

/**
 * Regra única de "este evento tem networking".
 *
 * Vivia embutida no `NetworkingSection`, que retornava `null` quando não havia
 * nem vocabulário no evento nem tag declarada pelo participante. Com a seção
 * virando rota própria em `/minha-conta`, a mesma decisão passou a ser
 * necessária em dois lugares a mais — a entrada na faixa de navegação e a
 * guarda da rota. Duplicar a condição faria a navegação e o conteúdo divergirem
 * no dia em que a regra mudasse.
 *
 * O participante que já declarou tags mantém acesso mesmo se o evento tiver
 * esvaziado o vocabulário depois — do contrário ele perderia a única via de
 * revisar o que declarou.
 */
export const useNetworkingAvailability = (): NetworkingAvailability => {
  const { digitalProductId } = useDigitalProductContext()
  const vocabulary = useNetworkingVocabulary()
  const { data: declaration, isLoading } = useNetworkingDeclarationQuery(digitalProductId)

  const declaredTags = declaration?.networking_tags ?? []

  return {
    isLoading,
    isAvailable: vocabulary.length > 0 || declaredTags.length > 0
  }
}
